import ApexNavigator from './src/index'

ApexNavigator.install = function(Vue) {
  Vue.component(ApexNavigator.name, ApexNavigator)
}

export default ApexNavigator
